export default __webpack_public_path__ + "locales/ro/InviteDialog.json?hash=2e2cefca52348640ad67337df3975157";